import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getDefaultRequestHeaderParams } from '../../utils/getRequestHeaderParams';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';

@Injectable({
  providedIn: 'root',
})
export class EmailTranscriptService {
  constructor(private http: HttpClient) {}

  requestEmailTranscript({ name, email, sessionId, chatId, language }) {
    const formData = {
      contactFirstName: name,
      contactLastName: 'lastName', // Static text for now as it's a required field
      contactEmail: email,
      ipAddress: '0.0.0.0', // Static text for now as it's a required field
    };
    return this.http.post(
      getChatApiBaseUrl() + '/ucx-transcript/transcript/va-boldchat',
      formData,
      {
        headers: {
          ...getDefaultRequestHeaderParams({
            'account-id': '000000', // Dummy value
            'session-identifier': sessionId,
            'chat-identifier': chatId ? chatId : '',
            lang: language ? language.toUpperCase() : '',
          }),
        },
        withCredentials: true,
      }
    );
  }
}
